export default class AccessRequestViewModel {
    name: string = "";
    email: string = "";
    licence: string = "";
}
